import React, { useEffect } from 'react'
import { Container, Button, Alert } from 'react-bootstrap';
import Article from './Article/Article';
import { useTranslation } from 'react-i18next';
import { FadeLoader } from 'react-spinners';

const ArticlesList = ({ contents, isLoading, getMoreAssets, next }) => {
  const { t } = useTranslation();

  return (
    <Container fluid className='panel panel-body d-flex flex-column align-items-center justify-content-center'>
      {isLoading ? (
        <Container fluid style={{ "height": "120px" }} className="d-flex justify-content-center">
          <FadeLoader
            color="#1a6fb8"
            height={25}
            loading
            margin={15}
            radius={2}
            speedMultiplier={1.5}
            width={3}
          />
        </Container>
      ) : (
        <>
          {(contents && contents.length !== 0) ? (
            <>
              {contents?.map((article) => {
                return (
                  <Article key={article.globalAssetId} articleContent={article}></Article>
                );
              })}
              {next && <Button variant="outline-secondary" className='more-btn w-100' onClick={getMoreAssets}>{t('more')}</Button>}
            </>
          ) : (
            <Alert variant="info" className="w-100 h-100 m-0">{t('no_results')}</Alert>
          )}
        </>
      )}
    </Container>
  );
};

export default ArticlesList